import React from 'react'

import { Alert, AlertTitle } from '@mui/material'
import { NormalizedErrors } from '@shared/utils/api/api.util'
import makeStyles from '@mui/styles/makeStyles'

type Props = {
  errors: NormalizedErrors | null
  onClose?: () => void
}

export function ErrorsAlert(props: Props) {
  const classes = useStyles()

  return props.errors ? (
    <Alert severity="error" onClose={props.onClose} className={classes.alert}>
      <AlertTitle>Błąd</AlertTitle>
      <ul>
        {props.errors.map((error) => (
          <li key={error}>{error}</li>
        ))}
      </ul>
    </Alert>
  ) : null
}

const useStyles = makeStyles((theme) => ({
  alert: {
    marginBottom: theme.spacing(2),
  },
}))
